
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { Department, DepartmentGroup } from "../../../../domain/department";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";
import { DepartmentFilterParameter } from "../../filters";
import DepartmentFilter from "../../filters/DepartmentFilter.vue";

@Component({
  components: {
    DepartmentFilter,
  },
})
export default class DepartmentSelectableDialogMixin extends Mixins(SelectorDialogMixin) {
  get title(): string {
    return this.name + "選択";
  }

  data(): any {
    return {
      filter: new DepartmentFilterParameter(),
      name: "診療科",
      nonDisplayDepartmentCodes: null as string[],
      departmentGroup: null,
      defaultMultiSelect: false,
    };
  }
  filter: DepartmentFilterParameter;
  name: string;
  nonDisplayDepartmentCodes: string[];
  departmentGroup: DepartmentGroup;
  defaultMultiSelect: boolean;

  get appliedFilter(): (source: Department) => boolean {
    return s => 
      (!this.nonDisplayDepartmentCodes || !Enumerable.from(this.nonDisplayDepartmentCodes).contains(s.id))
      && this.filter.filter(s);
  }
}
